import { v4 } from 'uuid';

export const getSessionId = () => {
  let sessionId = sessionStorage.getItem('sessionId');
  if (!sessionId) {
    sessionId = v4();
    sessionStorage.setItem('sessionId', sessionId);
  }

  return sessionId;
};

export default {
  getSessionId
};
